import React from "react";
import {
  compose,
  branch,
  renderNothing,
  renderComponent,
  mapProps,
  withState
} from "recompose";
import { LIST } from "./constants";
import { Link, withRouter } from "react-router-dom";
import styled from "styled-components";
import {
  Colors,
  Spinner,
  Button,
  Classes,
  InputGroup
} from "@blueprintjs/core";
import { withTopics, fetchTopics } from "./hocs";

import { FormattedMessage, injectIntl } from "react-intl";

// NOTE the !important on margin is needed to overwrite the children
// inhertiance from the layout
const Root = styled.div`
  display: flex;
  flex-flow: row wrap;
  justify-content: center;
  padding: 10px;
  padding-bottom: 10px;
  margin: 0 !important;
`;

const Wrapper = styled.div`
  display: block;
  width: 100%;
`;

const ListWrapper = styled.div`
  display: flex;
  flex-flow: row wrap;
  justify-content: center;
`;

const NoTopicFound = styled.div`
  display: flex;
  flex-flow: row wrap;
  justify-content: center;
  margin-top: 20px;
`;

const linkColor = Colors.DARK_GRAY5;

const TopicItem = styled(Link)`
  flex 1;
  min-width: 200px;
  color: ${linkColor};
  margin: 10px;
  text-align: center;
  &:hover {
    color: ${linkColor};
    text-decoration: none;
    // transform:translate(0px,-2px);
  }
  & .topic-label {
    margin: 10px 0;
  }
  & .topic-description {
    font-size: .75em;
    font-style: italic;
  }
`;

const Icon = styled.img`
  height: 4em;
  display: block;
  margin: 0 auto;
`;

const wrapRoot = Component => props => {
  return (
    <Root className="pt-ui-text-large">
      <Component {...props} />
    </Root>
  );
};

function filterTopics(topicsById, topicIds, term) {
  const topics = topicIds.map(id => topicsById[id]);
  const topicList = [
    "bike-rac",
    "sample-recovery-planning-rome",
    "5b76cfd34fbec800018a770f",
    "5b7a728c4fbec800018a7714",
    "upcycling-in-vienna",
    "6th-informed-cities-forum-map",
    "test-topic",
    "nicoles-urban-garden",
    "my-first-topic-eg"
  ];
  return topics.filter(topic => {
    if (topicList.includes(topic._id)) return;
    const topicContent = `${topic.title.toLowerCase()} ${topic.description.toLowerCase()}`;
    return topicContent.indexOf(term.toLowerCase()) > -1;
  });
}

let TopicList = props => {
  const {
    filterTerm,
    setFilterTerm,
    topics: { topicsById, topicIds },
    history,
    intl
  } = props;
  const filteredTopics = filterTopics(topicsById, topicIds, filterTerm);
  const topicElements = filteredTopics.map(topic => {
    const descriptionLength = 140;
    const overflowDescription = topic.description.length > descriptionLength;
    const topicDescription = overflowDescription
      ? topic.description.substr(0, descriptionLength) + "..."
      : topic.description;

    const path = `/topics/${topic.pathName}`;
    const urlSearch = window.location.search;

    return (
      <TopicItem
        to={path + urlSearch}
        key={topic._id}
        className="pt-interactive pt-card pt-elevation-1"
      >
        <Icon src={topic.icon} alt="icon" />
        <div className="topic-label">{topic.title}</div>
        <div
          className="topic-description"
          dangerouslySetInnerHTML={{ __html: topicDescription }}
        />
        {overflowDescription ? (
          <Button
            onClick={event => {
              event.preventDefault();
              history.push(path + "/details");
            }}
            className={`${Classes.MINIMAL} ${Classes.INTENT_PRIMARY}`}
          >
            <FormattedMessage
              id="app.home.readmore"
              defaultMessage="Read more"
            />
          </Button>
        ) : null}
      </TopicItem>
    );
  });
  return (
    <Wrapper>
      <InputGroup
        type="text"
        value={filterTerm}
        onChange={({ target: { value } }) => setFilterTerm(value)}
        placeholder={intl.formatMessage({
          id: "topiclist.filter.title",
          defaultMessage: "Filter by title…"
        })}
        style={{
          margin: "0 10px",
          width: "calc(100% - 20px)"
        }}
      />
      {topicElements.length > 0 ? (
        <ListWrapper>{topicElements}</ListWrapper>
      ) : (
        <NoTopicFound>No topic found.</NoTopicFound>
      )}
    </Wrapper>
  );
};

const LargeSpinner = () => <Spinner className="pt-large" />;

const ListError = ({ actions }) =>
  `Error while fetching topics: ${actions[LIST].data.message}`;

const NoTopics = () =>
  "No topics found. Please ask a topic administrator to add topics.";

const withCases = compose(
  mapProps(props => {
    const {
      topics: { actions }
    } = props;
    return {
      actions,
      [actions[LIST].type]: true
    };
  }),
  branch(props => props[LIST.PENDING], renderComponent(LargeSpinner)),
  branch(props => props[LIST.SUCCESS], renderComponent(NoTopics)),
  branch(props => props[LIST.ERROR], renderComponent(ListError)),
  renderNothing
);

export default compose(
  withState("filterTerm", "setFilterTerm", ""),
  withTopics,
  fetchTopics,
  branch(({ topics: { actions } }) => !actions[LIST], renderNothing),
  wrapRoot,
  branch(({ topics: { topicIds } }) => topicIds.length <= 0, withCases),
  withRouter,
  injectIntl
)(TopicList);



// WEBPACK FOOTER //
// ./src/app/topics/TopicList.js